<template>
    <div class="product_features main_width m_0">
        <div class="title">产品功能</div>
        <div class="content VIN">
            <div class="VIN_left">
                <div class="content_left_title">VIN车架号查询服务</div>
                <div class="line">
                    <div class="block"></div>
                </div>
                <div class="text">通过VIN可以查询到汽车品牌、车型、发动机、配置及图片等多项信息。通过 人工智能算法进行建模分析不断优化验证，配合人工纠错累积让数据越来越 精准。为汽配汽修从业者、车主以及二手车交易从业者提供有力支持。</div>
                <div class="text2"><div class="disc"></div>车型信息丰富，多维度数据库</div>
                <div class="text">546个品牌数量、15W+条车型数量、212项参数配置</div>
                <div class="text2"><div class="disc"></div>车型覆盖齐全，VIN数据精准</div>
                <div class="text">3.2亿条人工校验数据、保有量覆盖91%、综合查得率98%</div>
                <div class="text2"><div class="disc"></div>用户基数庞大</div>
                <div class="text">3500万真实用户、日查询量达100万+</div>
            </div>
            <img src="../../../static/images2/VIN_img.webp" alt="">
        </div>
        <div class="content OE">
            <img src="../../../static/images2/OE_img.webp" alt="">
            <div class="OE_right">
                <div class="content_left_title">OE号查询</div>
                <div class="line">
                    <div class="block"></div>
                </div>
                <div class="text">涵盖超过3000万个零部件的OE信息，快速查询配件详细信息</div>
                <ul class="text3">
                    <li>海量配件数据</li>
                    <li>快速适配，提高交易效率</li>
                    <li>库存管理支持，SKU信息在线共享</li>
                </ul>
            </div>
        </div>
        <div class="content EPC">
            <div class="EPC_left">
                <div class="content_left_title">EPC查询</div>
                <div class="line">
                    <div class="block"></div>
                </div>
                <p class="text">汽修宝EPC涵盖了90个品牌配件数据，可精准定位到所属车型、适配 部件以及最新参考价格等核心信息。</p>
                <ul class="text3">
                    <li>配件信息详细，可直接查询安装位置、用量与所属车型</li>
                    <li>品牌覆盖广泛，通过VIN锁定唯一车型精准匹配</li>
                    <li>查询便捷高效，可视化展示100+主流品牌零件结构</li>
                </ul>
            </div>
            <img src="../../../static/images2/EPC_img.webp" alt="">
        </div>
    </div>
</template>
<script>
export default {
  name: "productFeatures"
}

</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.product_features {
    margin: .px2vw(48)[@result] auto .px2vw(32)[@result];
    .title {
        text-align: center;
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(24)[@result];
    }
    .content {
        height: .px2vw(550)[@result];
        width: .px2vw(1280)[@result];
        display: flex;
        align-items: center;
        font-size: .px2vw(14)[@result];
        color: #4E5969;
        line-height: .px2vw(22)[@result];
        text-align: justify;
        margin: auto;
        margin-bottom: .px2vw(32)[@result];
        .content_left_title {
            font-weight: 700;
            font-size: .px2vw(32)[@result];
            line-height: .px2vw(40)[@result];
            color: #1D2129;
            margin-bottom: .px2vw(16)[@result];
        }
        .line {
            width: .px2vw(362)[@result];
            height: .px2vw(4)[@result];
            border-bottom: .px2vw(1)[@result] solid #D8D8D8;
            margin-bottom: .px2vw(24)[@result];
            .block {
                width: .px2vw(70)[@result];
                height: .px2vw(4)[@result];
                background: #165DFF;
            }
        }
        .text {
            margin-bottom: .px2vw(16)[@result];
        }
        .text2 {
            margin-bottom: .px2vw(8)[@result];
            font-weight: 500;
            font-size: .px2vw(16)[@result];
            color: #165DFF;
            line-height: .px2vw(24)[@result];
            display: flex;
            align-items: center;
        }
        .text3 {
            font-weight: 500;
            font-size: .px2vw(16)[@result];
            color: #165DFF;
            li {
                margin-bottom: .px2vw(16)[@result];
                position: relative;
                margin-left: .px2vw(22)[@result];
            }
            li::before {
                content: "";
                display: inline-block;
                width: .px2vw(16)[@result];
                height: .px2vw(16)[@result];
                background-image: url("../../../static/images2/success.webp");
                background-size: contain;
                position: absolute;
                left: .px2vw(-22)[@result];
                top: .px2vw(3)[@result];
            }
        }
        .disc {
            width: .px2vw(3)[@result];
            height: .px2vw(3)[@result];
            border-radius: 50%;
            background-color: #165DFF;
            margin: 0 .px2vw(6)[@result];
        }
    }
    .VIN {
        img {
            width: .px2vw(675)[@result];
            height: .px2vw(498)[@result];
            margin: 0 .px2vw(40)[@result] 0 .px2vw(46)[@result];
        }
        .VIN_left {
            margin-left: .px2vw(48)[@result];
        }
    }
    .OE {
        img {
            width: .px2vw(623)[@result];
            height: .px2vw(325)[@result];
            margin: 0 .px2vw(83)[@result];
        }
    }
    .EPC {
        img {
            width: .px2vw(504)[@result];
            height: .px2vw(512)[@result];
        }
        .EPC_left {
            margin: 0 .px2vw(167)[@result] 0 .px2vw(53)[@result];
        }

    }
}
@media screen and (max-width: 900px) {
    .product_features {
        padding: .h5px2vw(32)[@result];
        .title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(32)[@result];
        }
        .content {
            height: auto;
            width: 100%;
            flex-direction: column-reverse;
            font-size: .h5px2vw(24)[@result];
            line-height: .h5px2vw(32)[@result];
            // margin-bottom: .px2vw(32)[@result];
            .content_left_title {
                font-size: .h5px2vw(28)[@result];
                line-height: .h5px2vw(36)[@result];
                margin-bottom: .h5px2vw(16)[@result];
                text-align: center;
            }
            .line {
                display: none;
            }
            .text {
                margin-bottom: .h5px2vw(24)[@result];
            }
            .text2 {
                margin-bottom: .h5px2vw(8)[@result];
                font-size: .h5px2vw(24)[@result];
                line-height: .h5px2vw(32)[@result];
            }
            .text3 {
                font-size: .h5px2vw(24)[@result];
                li {
                    margin-bottom: .h5px2vw(16)[@result];
                    margin-left: .h5px2vw(28)[@result];
                }
                li::before {
                    width: .h5px2vw(24)[@result];
                    height: .h5px2vw(24)[@result];
                    left: .h5px2vw(-28)[@result];
                    top: .h5px2vw(4)[@result];
                }
            }
            .disc {
                width: .h5px2vw(3)[@result];
                height: .h5px2vw(3)[@result];
                border-radius: 50%;
                background-color: #165DFF;
                margin: 0 .h5px2vw(6)[@result];
            }
            img {
                margin-bottom: .h5px2vw(32)[@result];
            }
        }
        .VIN {
            img {
                width: .h5px2vw(686)[@result];
                height: .h5px2vw(506)[@result];
                margin: 0 .h5px2vw(8)[@result] .h5px2vw(32)[@result];
            }
        }
        .OE {
            flex-direction: column;
            img {
                width: .h5px2vw(623)[@result];
                height: .h5px2vw(325)[@result];
                margin: 0 .h5px2vw(40)[@result] .h5px2vw(32)[@result];
            }
        }
        .EPC {
            img {
                width: .h5px2vw(504)[@result];
                height: .h5px2vw(512)[@result];
                margin: 0 .h5px2vw(99)[@result] .h5px2vw(32)[@result];
            }
            .EPC_left {
                margin: 0;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/QXB/productFeatures.vue